import { useEffect, useState, useRef } from 'react';
export const useFullscreenLoader = () => {
  const _useState = useState(false),
    isFullscreenLoaded = _useState[0],
    setIsFullscreenLoaded = _useState[1];
  const FullscreenElementRef = useRef(null);
  const loadFullscreenModuleIfNeeded = () => {
    import( /* webpackChunkName: "pro-fullscreen-renderer" */'@wix/native-pro-gallery-fullscreen').then(module => {
      FullscreenElementRef.current = module.ProFullscreen;
      setIsFullscreenLoaded(true);
    });
  };
  useEffect(() => {
    loadFullscreenModuleIfNeeded();
  }, []);
  return [isFullscreenLoaded, FullscreenElementRef.current];
};
//# sourceMappingURL=useFullscreenLoader.js.map